import { FormGroup } from "@angular/forms";

export class EvForm {

    form: FormGroup = new FormGroup([])

    get valid() {
        return this.form.valid
    }
}